export default "__VITE_ASSET__0721bf44__"